/**
 * @generated SignedSource<<e1c3dcda1e5299cc87973f4d9144a961>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionAutocompleteFragmentPaginationQuery$variables = {
  count?: number | null | undefined;
  search?: string | null | undefined;
};
export type CompetitionAutocompleteFragmentPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionAutocompleteFragment">;
};
export type CompetitionAutocompleteFragmentPaginationQuery = {
  response: CompetitionAutocompleteFragmentPaginationQuery$data;
  variables: CompetitionAutocompleteFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CompetitionAutocompleteFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionAutocompleteFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
          },
          (v1/*: any*/)
        ],
        "concreteType": "CompetitionConnection",
        "kind": "LinkedField",
        "name": "competitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Competition",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea25839a3025f5a9a6134a6b2e0ba1a2",
    "id": null,
    "metadata": {},
    "name": "CompetitionAutocompleteFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query CompetitionAutocompleteFragmentPaginationQuery(\n  $count: Int = 10\n  $search: String\n) {\n  ...CompetitionAutocompleteFragment_3DeKgW\n}\n\nfragment CompetitionAutocompleteFragment_3DeKgW on Query {\n  competitions(first: $count, search: $search) {\n    edges {\n      node {\n        id\n        title\n        slug\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca9dac158e9466f166d80c6861e5564c";

export default node;
